const siteTitle = "Engineering for Humanity";

const pages = [
  "overview",
  "activities",
  "videos",
  "stories",
  "course"
];

const apiUrl = "https://backend.courses.olin.edu/jsonapi";
const baseUrl = "https://backend.courses.olin.edu/";

const captchaKey = "6LdEH-cUAAAAAIwCdssPe_mKz6EBWbwINdluNHqB";

export { pages, siteTitle, apiUrl, baseUrl, captchaKey };
